/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
// structure
import Division from 'material/structure/division/division';
import Header from 'material/structure/header/header_container';
import Body from 'material/structure/body/body_container';
import Footer from 'material/structure/footer/footer_container';
// pages
// import UIKitPage from 'pages/uikit/uikit_container';
import Home from 'pages/dashboard/home/home_container';
import Embeds from 'pages/dashboard/embeds/embeds_container';
import Reports from 'pages/dashboard/reports/reports_container';
import Detail from 'pages/dashboard/analytics/detail/detail_container';
import Account from 'pages/dashboard/account/account_container';
import MyProfile from 'pages/dashboard/myprofile/myprofile_container';
// styles
// import injectSheet from 'react-jss';
// import styles from 'pages/dashboard/dashboard_styles';



/* ========== ~~~~~~~~~~ DASHBOARD : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const Dashboard = (props) => {
    return(
        <Division name={`dashboard`}>
            <Header />
            <Body>
                <Switch>
                    {/*Routes to subsections*/}
                    <Route path='/dashboard/home' component={Home} />{/*/(dashboard/|dashboard/home)/*/}
                    <Route path='/dashboard/analytics/detail' component={Detail} />
                    <Route path='/dashboard/embeds' component={Embeds} />
                    <Route path='/dashboard/reports' component={Reports} />
                    <Route path='/dashboard/account' component={Account} />
                    <Route path='/dashboard/profile' component={MyProfile} />
                    <Redirect to='/error/404' />
                </Switch>
            </Body>
            <Footer />
        </Division>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default Dashboard;
// export default injectSheet(styles)(Dashboard);